var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-container"},[(!_vm.hideBar)?_c('v-divider',{staticClass:"mt-5"}):_vm._e(),_c('div',{staticClass:"button-bar"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }